module.exports = __webpack_public_path__ + "assets/images/icons/icon_virus-red.svg?v=27e9069b";